<div class="curtain">

<section  class="component-modalDialog redesigned size-4" id="test-addOrEditDocumentDialog">

    <header>
        Upravit naskenovaný dokument
        <a class="closeModalDialog fa fa-close" (click)="closeModal(false)"></a>
    </header>

    <div class="contentContainer scrollable nativeScrollbar inside">
        <ca-loading  [loadState]="loading">
        <form *ngIf="!loading">
            <ca-attachment-type-scan-data [mode]="mode" [task]="task"></ca-attachment-type-scan-data>
        </form>
        </ca-loading>
    </div>

    <footer *ngIf="!loading">
        <a class="button-primary"(click)="saveEditedScan()">Uložit</a>
        <a class="button-secondary" (click)="closeModal(null)">Storno</a>
    </footer>
</section>

</div><!-- curtain -->